import { User } from 'models/User';

export const generateAuthPath = (user: User) => {
  let currentRoute;
  if (user.hasTmpPassword) currentRoute = '/change-password';
  else if (!user.phoneNumber) currentRoute = '/add-phone';
  else if (!user.isPhoneNumberConfirmed) currentRoute = '/verify-phone';

  return '/auth' + currentRoute;
};
